import { render, staticRenderFns } from "./claimSettlementList.vue?vue&type=template&id=4fb8a08a&scoped=true"
import script from "./claimSettlementList.vue?vue&type=script&lang=js"
export * from "./claimSettlementList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./claimSettlementList.vue?vue&type=style&index=1&id=4fb8a08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb8a08a",
  null
  
)

export default component.exports